export default __webpack_public_path__ + "static/media/back_arrow_icon.37365d0d.svg";